export default {
  free: 'FREE',
  save: 'Save {{amount}}',
};
